mama-form-textarea {
  display: block;
  position: relative;

  label {
    position: absolute;
    left: 3px;
    z-index: 2;
    transition: $transition-ease-out;
    top: 28px;
    cursor: text;
  }

  &.focus {
    label {
      top: -6px;
      font-size: 0.875rem;
      cursor: pointer;
    }
  }

  .counter {
    position: absolute;
    right: 1.75rem;
    bottom: 0.5rem;
    font-size: $font-size-sm;
  }
}
